import React, { ReactElement } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { normalizeUserRefId } from '@actions/SideNav/sideNavActionCreators';
import { useAppSelector } from '@hooks/index';
import { environmentSelector } from '@selectors/commonSelectors';
import { configs } from '@constants/configs/configs';

interface ICapHistoricalRouteGuardProps {
    element: ReactElement;
}

/** Redirects unless `showHistoricalLinking` is on and the URL carries a reference id. */
const CapHistoricalRouteGuard: React.FC<ICapHistoricalRouteGuardProps> = ({ element }) => {
    const showHistoricalLinking = useAppSelector(environmentSelector)?.showHistoricalLinking;
    const [searchParams] = useSearchParams();
    const referenceId = normalizeUserRefId(searchParams.get('referenceId'));

    if (!showHistoricalLinking || !referenceId) {
        return <Navigate to={configs.routes.FALLBACK} replace />;
    }

    return element;
};

export default CapHistoricalRouteGuard;
